import * as ResultsPatents from './resultsPatents.js';
export default ResultsPatents;
